import { Component, EventEmitter, inject, Input, OnChanges, Output } from '@angular/core';
import { TtmTicket } from '../../classes/ttm-ticket.class';
import { CodaltComponent } from '../codalt/codalt.component';
import { AuthenticationService } from './../../services/auth/authentication.service';
import { LocalStorage } from '../../utils/storage';
import { TtmTicketService } from '../../services/ttm-ticket.service';

@Component({
    selector: 'app-ttm-ticket-card',
    templateUrl: './ttm-ticket-card.component.html',
    styleUrls: ['./ttm-ticket-card.component.scss']
})
export class TtmTicketCardComponent extends CodaltComponent implements OnChanges {
    @Input() ticket: TtmTicket;
    @Output() deleteTicket = new EventEmitter<TtmTicket>();

    isNewTicket = false;

    authService = inject(AuthenticationService);
    private ttmTicketService = inject(TtmTicketService);

    constructor() {
        super();
    }

    ngOnChanges() {
        const userId = LocalStorage.user?.id;
        this.isNewTicket = this.ticket.status === 'new' && (this.ticket.assignee_id === userId || this.ticket.user_id === userId);
    }

    // Only toggles this ticket; the setting is stored on the ticket itself, so the list stays in sync
    toggleMuteNotifications() {
        const action$ = this.ticket.is_muted?.email_enabled
            ? this.ttmTicketService.muteNotifications(this.ticket.id)
            : this.ttmTicketService.unmuteNotifications(this.ticket.id);

        this.subscriptions.add(
            action$.subscribe(response => this.ticket.is_muted = response.data)
        );
    }
}
